import actions from '@/Core.Service.Domain/Controls/AHUs/Store/actions.ts';
import getters from '@/Core.Service.Domain/Controls/AHUs/Store/getters.ts';
import mutations from '@/Core.Service.Domain/Controls/AHUs/Store/mutations.ts';

import { IAHU } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

const state = {
  editAHU: {} as IAHU,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
